import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { ReservationsServices } from '../services';
import { ReservationCreatePage } from '../reservation-create/reservation-create';
import { ReservationManualCreatePage } from '../reservation-manual-create/reservation-manual-create';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';


@Component({
    selector: 'page-reservation-denied-list',
    templateUrl: 'reservation-denied-list.html',
})
export class ReservationDeniedListPage {

    denied_reservations: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        public reservationsServices: ReservationsServices) {

        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: ''
        });
        loadingPopup.present();
        this.deniedReservations();
        loadingPopup.dismiss();
    }

    ionViewWillEnter() {
        this.deniedReservations();
    }

    async deniedReservations() {

        this.denied_reservations = await this.reservationsServices.getReservationsCanceled(this.globals.restaurant_uid);
        

    }

    openReservation(reservation) {
        this.navCtrl.push(ReservationCreatePage, {
            reservation: reservation,
            update_state: true,
        });
    }

    createReservation() {
        if(this.globals.checkLimitsByLicense('reservations', 'calendar')) {
            this.navCtrl.push(ReservationManualCreatePage);
          } else{
            this.navCtrl.push(AddonsTriggerVersionProPage);
          }  
        }


}



// WEBPACK FOOTER //
// ./src/pages/reservation/reservation-denied-list/reservation-denied-list.ts